import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import DropdownBox from '../../components/Dropdown/DropdownBox/DropdownBox';
import Option from '../../components/Dropdown/DropdownOption/DropdownOption';
import { getInDomain } from '../../domains/externalUtils';

export const ArtistAllAlbumsSortDropdownKey = Symbol('ArtistAllAlbumsSortDropdown');

const ArtistAllAlbumsSortDropdown = props => {
  const { childProps } = props;
  const { sortTypes, activeSort, onSortClicked } = childProps;
  const messages = getInDomain('backstage.constants.ArtistAllAlbumsSortMessages');

  return (
    <DropdownBox>
      {sortTypes.map(sortType => {
        return (
          <Option
            key={sortType}
            isSelectable={true}
            extrasStyles={['DropdownOption--black']}
            label={<FormattedMessage {...messages[sortType]} />}
            isSelected={sortType === activeSort}
            callback={() => onSortClicked(sortType)}
          />
        );
      })}
    </DropdownBox>
  );
};

ArtistAllAlbumsSortDropdown.propTypes = {
  childProps: PropTypes.shape({
    onSortClicked: PropTypes.func,
    sortTypes: PropTypes.object,
    activeSort: PropTypes.string,
  }),
};

export const constructors = {
  [ArtistAllAlbumsSortDropdownKey]: ArtistAllAlbumsSortDropdown,
};
